import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import axios, { AxiosError } from "axios";
import { ttProtectionUrls } from "../../../URL/ApplicationUrls";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useCreateTtProtectionFromSpdrs = () => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (spdrIds: number[]) => {
      return axios.post<number>(ttProtectionUrls.ttProtectionFromSpdrs, spdrIds);
    },
    onSuccess: async (result) => navigate(ttProtectionUrls.detailsFor(result.data)),
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
